
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  fetchParkDetails,
  updateParkDetails,
} from "../redux/actions/parkdetailsActions";

import {
  fetchDistricts,
  fetchMunicipalities,
} from "../redux/actions/locationActions";

import Papa from "papaparse";
import theme from "../components/shared/theme";

import {
  dropdownStyle,
  thStyle,
  tdStyle,
  paginationButtonStyle,
} from "../components/shared/themeStyles";

import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import EditParkModal from "./parkDetails_management/EditParkModal";

// ✅ MOVE THIS HERE (AFTER ALL IMPORTS)
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Add this component for truncating text with "See more"
const TruncatedText = ({ text, maxLength = 20 }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  if (!text) return <span>-</span>;
  
  if (text.length <= maxLength) {
    return <span>{text}</span>;
  }
  
  return (
    <div style={{ position: "relative" }}>
      <span>
        {isExpanded ? text : `${text.substring(0, maxLength)}...`}
      </span>
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          backgroundColor: "transparent",
          border: "none",
          color: theme.colors.primary,
          cursor: "pointer",
          fontSize: "0.8rem",
          marginLeft: "4px",
          padding: "0",
          textDecoration: "underline"
        }}
      >
        {isExpanded ? "See less" : "See more"}
      </button>
    </div>
  );
};
const ParkDetails = () => {
  const dispatch = useDispatch();

  const { parkDetails, pagination } = useSelector(
    (state) => state.parkDetails
  );
  const { districts, municipalities } = useSelector((state) => state.location);

  const totalPages = pagination?.totalPages || 1;

  const [page, setPage] = useState(1);
  const [limit] = useState(20);

  const [search, setSearch] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedMunicipality, setSelectedMunicipality] = useState("");
  const [projectType, setProjectType] = useState("");

  const [isEditOpen, setIsEditOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);

  // Load filter data
  useEffect(() => {
    dispatch(fetchDistricts());
    dispatch(fetchMunicipalities());
  }, [dispatch]);

  // Reset municipality when district changes
  useEffect(() => {
    setSelectedMunicipality("");
  }, [selectedDistrict]);

  // Fetch filtered data
  useEffect(() => {
    dispatch(
      fetchParkDetails({
        page,
        limit,
        project_type: projectType,
        district: selectedDistrict,
        municipality: selectedMunicipality,
        search,
      })
    );
  }, [
    dispatch,
    page,
    limit,
    projectType,
    selectedDistrict,
    selectedMunicipality,
    search,
  ]);

  // Filter municipality based on district
  const filteredMunicipalities = selectedDistrict
    ? municipalities.filter((m) => m.district_id == selectedDistrict)
    : municipalities;

  // CSV Export


const handleDownloadCSV = async () => {
  try {
    const token = localStorage.getItem("token");

    const queryParams = new URLSearchParams({
      page: 1,
      limit: 100000,
      project_type: projectType || "",
      district: selectedDistrict || "",
      municipality: selectedMunicipality || "",
      search: search || "",
    }).toString();

    const response = await fetch(`${BASE_URL}/v1/api/admin/park_details?${queryParams}`, {
      headers: { authorization: token },
    });

    const result = await response.json();
    const dataList = result?.data || [];

    if (!dataList.length) {
      alert("No data available to download.");
      return;
    }

    // Transform data into objects
    const csvData = dataList.map((item) => ({
      ID: item.id || "",
      Ward: item.ward || "",
      "Project Code": item.project_code || "",
      "Stretch Name": item.park_stretch_name || "",
      "Project Type": item.project_type || "",
      District: item.district_name || "",
      Municipality: item.municipality_name || "",
      "Created At": item.created_at
        ? new Date(item.created_at).toLocaleDateString("en-IN")
        : "",
      Username: item.username || "",
    }));

    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "ParkDetails_Report.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("CSV Download Failed:", error);
    alert("Failed to download CSV. Please try again.");
  }
};


  // Edit Modal
  const handleEditClick = (item) => {
    setEditItem(item);
    setIsEditOpen(true);
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    await dispatch(updateParkDetails(editItem.id, editItem));
    setIsEditOpen(false);

    dispatch(
      fetchParkDetails({
        page,
        limit,
        project_type: projectType,
        district: selectedDistrict,
        municipality: selectedMunicipality,
        search,
      })
    );
  };

  return (
    <div
      style={{
        padding: theme.spacing.lg,
        backgroundColor: theme.colors.background,
        minHeight: "100vh",
      }}
    >
      <h1
        style={{
          fontSize: theme.font.size["3xl"],
          fontWeight: theme.font.weight.bold,
          color: theme.colors.grayDark,
          marginBottom: theme.spacing.lg,
        }}
      >
        Park / Stretch Details Management
      </h1>

      {/* Filters */}
      <div
        style={{
          marginBottom: theme.spacing.lg,
          display: "flex",
          gap: theme.spacing.sm,
          flexWrap: "wrap",
        }}
      >
        {/* District */}
        <select
          value={selectedDistrict}
          onChange={(e) => setSelectedDistrict(e.target.value)}
          style={dropdownStyle}
        >
          <option value="">All Districts</option>
          {districts.map((d) => (
            <option key={d.id} value={d.id}>
              {d.name}
            </option>
          ))}
        </select>

        {/* Municipality */}
        <select
          value={selectedMunicipality}
          onChange={(e) => setSelectedMunicipality(e.target.value)}
          style={dropdownStyle}
        >
          <option value="">All Municipalities</option>
          {filteredMunicipalities.map((m) => (
            <option key={m.id} value={m.id}>
              {m.name}
            </option>
          ))}
        </select>

        {/* Project Type */}
        <select
          value={projectType}
          onChange={(e) => setProjectType(e.target.value)}
          style={dropdownStyle}
        >
          <option value="">All Types</option>
          <option value="Park">Park</option>
          <option value="Stretch">Stretch</option>
          <option value="Shelter">Shelter</option>
        </select>

        {/* Search */}
        <input
          type="text"
          placeholder="Search project code, name, type…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            padding: theme.spacing.sm,
            borderRadius: theme.radius.md,
            minWidth: "250px",
            border: "1px solid #ccc",
          }}
        />

        <button
          onClick={handleDownloadCSV}
          style={{
            backgroundColor: theme.colors.secondary,
            color: "#fff",
            padding: theme.spacing.sm,
            borderRadius: theme.radius.md,
          }}
        >
          Export CSV
        </button>
      </div>

      {/* TABLE */}
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: theme.radius.lg,
          boxShadow: theme.shadow.soft,
          overflowX: "auto",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: theme.font.size.sm,
          }}
        >
          <thead
            style={{
              backgroundColor: theme.colors.grayDark,
              color: "#fff",
            }}
          >
            <tr>
              <th style={thStyle}>ID</th>
              <th style={thStyle}>Project Code</th>
              <th style={thStyle}>Stretch Name</th>
              <th style={thStyle}>Project Type</th>
              <th style={thStyle}>Ward</th>
              <th style={thStyle}>District</th>
              <th style={thStyle}>Municipality</th>
              <th style={thStyle}>Created At</th>
              <th style={thStyle}>Username</th>
              <th style={thStyle}>Actions</th>
            </tr>
          </thead>

          {/* <tbody>
            {parkDetails.map((item) => (
              <tr key={item.id} style={{ borderBottom: "1px solid #eee" }}>
                <td style={tdStyle}>{item.id}</td>
                <td style={tdStyle}>{item.project_code}</td>
                <td style={tdStyle}>{item.park_stretch_name}</td>
                <td style={tdStyle}>{item.project_type}</td>
                <td style={tdStyle}>{item.ward}</td>
                <td style={tdStyle}>{item.district_name}</td>
                <td style={tdStyle}>{item.municipality_name}</td>
                <td style={tdStyle}>
                  {new Date(item.created_at).toLocaleDateString("en-IN")}
                </td>
                <td style={tdStyle}>{item.username}</td>

                <td style={tdStyle}>
                  <button
                    onClick={() => handleEditClick(item)}
                    style={{
                      backgroundColor: theme.colors.primary,
                      color: "#fff",
                      padding: "4px 8px",
                      borderRadius: theme.radius.sm,
                    }}
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody> */}
        
<tbody>
  {parkDetails.map((item) => (
    <tr key={item.id} style={{ borderBottom: "1px solid #eee" }}>
      <td style={tdStyle}>{item.id}</td>
      
      {/* Project Code */}
      <td style={tdStyle}>
        <TruncatedText text={item.project_code} maxLength={25} />
      </td>
      
      {/* Stretch Name */}
      <td style={tdStyle}>
        <TruncatedText text={item.park_stretch_name} maxLength={20} />
      </td>
      
      <td style={tdStyle}>{item.project_type}</td>
      
      {/* Ward */}
      <td style={tdStyle}>
        <TruncatedText text={item.ward} maxLength={5} />
      </td>
      
      <td style={tdStyle}>{item.district_name}</td>
      <td style={tdStyle}>{item.municipality_name}</td>
      <td style={tdStyle}>
        {new Date(item.created_at).toLocaleDateString("en-IN")}
      </td>
      <td style={tdStyle}>{item.username}</td>

      <td style={tdStyle}>
        <button
          onClick={() => handleEditClick(item)}
          style={{
            backgroundColor: theme.colors.primary,
            color: "#fff",
            padding: "4px 8px",
            borderRadius: theme.radius.sm,
          }}
        >
          Edit
        </button>
      </td>
    </tr>
  ))}
</tbody>
        </table>
      </div>

      {/* PAGINATION */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: theme.spacing.md,
        }}
      >
        <button
          onClick={() => setPage((prev) => Math.max(1, prev - 1))}
          disabled={page <= 1}
          style={paginationButtonStyle}
        >
          <FiChevronLeft /> Previous
        </button>

        <span>
          Page {page} of {totalPages}
        </span>

        <button
          onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))}
          disabled={page >= totalPages}
          style={paginationButtonStyle}
        >
          Next <FiChevronRight />
        </button>
      </div>

      {/* EDIT MODAL */}
      {isEditOpen && editItem && (
        <EditParkModal
          item={editItem}
          onChange={(field, value) =>
            setEditItem((prev) => ({ ...prev, [field]: value }))
          }
          onCancel={() => setIsEditOpen(false)}
          onSubmit={handleUpdateSubmit}
        />
      )}
    </div>
  );
};

export default ParkDetails;
